import { memo } from 'react';
import { BaseNodeUI } from './BaseNodeUI';
import { MapPin } from 'lucide-react';

const GeoNode = memo(({ data, selected }: any) => {
    return (
        <BaseNodeUI
            title={data.label || 'Geolocation'}
            icon={MapPin}
            colorClass="text-rose-600"
            bgClass="bg-rose-100/50"
            selected={selected}
            isSource={true}
            isTarget={true}
            hideHandles={false}
        />
    );
});

GeoNode.displayName = 'GeoNode';
export default GeoNode;
